export const getUserPermittedActions = userDetails =>
  userDetails?.permittedActions || [
    'urn:replicon:user-action:view-project-role',
    'urn:replicon:user-action:view-skill-assignments',
    'urn:replicon:user-action:view-supervisor',
    'urn:replicon:user-action:view-custom-fields'
  ];
